import { render, staticRenderFns } from "./shareReadingFeeList.vue?vue&type=template&id=6284cb40&scoped=true"
import script from "./shareReadingFeeList.vue?vue&type=script&lang=js"
export * from "./shareReadingFeeList.vue?vue&type=script&lang=js"
import style0 from "./shareReadingFeeList.vue?vue&type=style&index=0&id=6284cb40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6284cb40",
  null
  
)

export default component.exports